var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useMemo } from 'react';
import styled, { css } from 'styled-components';
import { colors, cssThemedValue, cssVarsThemed, typographyCss } from '@creditornot/cb-ingredients';
import { Tooltip } from '@creditornot/cb-popover';
import CaretDownIcon from './CaretDownIcon';
import InfoCircleFilledIcon from './InfoCircleFilledIcon';
var Root = styled.th(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  /* resets */\n  padding-top: 0;\n  padding-bottom: 0;\n  box-sizing: border-box;\n\n  position: relative;\n  z-index: 0;\n\n  ", "\n\n  ", "\n\n  :focus:not(:focus-visible) {\n    outline: none;\n  }\n  :focus-visible {\n    outline: none;\n    background-color: ", ";\n  }\n"], ["\n  /* resets */\n  padding-top: 0;\n  padding-bottom: 0;\n  box-sizing: border-box;\n\n  position: relative;\n  z-index: 0;\n\n  ", "\n\n  ", "\n\n  :focus:not(:focus-visible) {\n    outline: none;\n  }\n  :focus-visible {\n    outline: none;\n    background-color: ", ";\n  }\n"])), typographyCss.Subtitle, function (_a) {
    var $clickable = _a.$clickable;
    return $clickable && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      cursor: pointer;\n      &:active {\n        ", " {\n          opacity: 0.8;\n        }\n      }\n\n      &:hover {\n        ", " {\n          opacity: 1;\n        }\n      }\n    "], ["\n      cursor: pointer;\n      &:active {\n        ", " {\n          opacity: 0.8;\n        }\n      }\n\n      &:hover {\n        ", " {\n          opacity: 1;\n        }\n      }\n    "])), Content, InvisibleCaretIcon);
}, colors.wolt8);
var contentAlignmentMap = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
};
var textAlignmentMap = {
    left: 'start',
    center: 'center',
    right: 'end',
};
var CaretIcon = styled(CaretDownIcon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  flex-shrink: 0;\n  fill: var(--fill);\n  margin-inline-end: 4px;\n  width: 8px;\n  transition: transform 100ms ease-in;\n  transform: scaleY(", ");\n"], ["\n  ", "\n  flex-shrink: 0;\n  fill: var(--fill);\n  margin-inline-end: 4px;\n  width: 8px;\n  transition: transform 100ms ease-in;\n  transform: scaleY(", ");\n"])), cssVarsThemed({
    fill: { light: colors.pepper64, dark: colors.salt72 },
}), function (_a) {
    var $direction = _a.$direction;
    return ($direction === 'up' ? -1 : 1);
});
var InvisibleCaretIcon = styled(CaretIcon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  opacity: 0;\n  transition: opacity 100ms ease-in;\n"], ["\n  opacity: 0;\n  transition: opacity 100ms ease-in;\n"])));
var Content = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  text-align: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  text-align: ", ";\n"])), function (_a) {
    var $align = _a.$align;
    return contentAlignmentMap[$align];
}, function (_a) {
    var $align = _a.$align;
    return textAlignmentMap[$align];
});
var Name = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-inline-end: 4px;\n"], ["\n  margin-inline-end: 4px;\n"])));
var InfoIcon = styled(InfoCircleFilledIcon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  flex-shrink: 0;\n  width: 12px;\n  fill: ", ";\n  margin-inline-end: 4px;\n"], ["\n  flex-shrink: 0;\n  width: 12px;\n  fill: ", ";\n  margin-inline-end: 4px;\n"])), cssThemedValue('textSecondary'));
var HeaderColumn = function (_a) {
    var align = _a.align, children = _a.children, info = _a.info, onSortChange = _a.onSortChange, sortDirection = _a.sortDirection, _b = _a.sortDirections, sortDirections = _b === void 0 ? [] : _b, rest = __rest(_a, ["align", "children", "info", "onSortChange", "sortDirection", "sortDirections"]);
    var clickable = sortDirections.length > 0;
    var nextSortDirection = useMemo(function () {
        if (sortDirection === 'descend' && sortDirections.includes('ascend')) {
            return 'ascend';
        }
        else if (sortDirection === 'ascend' && sortDirections.includes('descend')) {
            return 'descend';
        }
        else if (sortDirections.includes('ascend')) {
            return 'ascend';
        }
        else if (sortDirections.includes('descend')) {
            return 'descend';
        }
        return sortDirection;
    }, [sortDirection, sortDirections]);
    var handleClick = useCallback(function () {
        if (onSortChange && nextSortDirection) {
            onSortChange(nextSortDirection);
        }
    }, [nextSortDirection, onSortChange]);
    var handleKeyPress = useCallback(function (event) {
        if (onSortChange && nextSortDirection && (event.key === ' ' || event.key === 'Enter')) {
            onSortChange(nextSortDirection);
        }
    }, [nextSortDirection, onSortChange]);
    return (React.createElement(Root, __assign({}, rest, { "$clickable": clickable, onClick: handleClick, onKeyPress: handleKeyPress, tabIndex: clickable ? 0 : undefined }),
        React.createElement(Content, { "$align": align },
            align === 'left' && children && React.createElement(Name, null, children),
            !!sortDirection && React.createElement(CaretIcon, { "$direction": sortDirection === 'ascend' ? 'up' : 'down' }),
            !sortDirection && sortDirections.length > 0 && (React.createElement(InvisibleCaretIcon, { "$direction": sortDirections.includes('ascend') ? 'up' : 'down' })),
            align === 'right' && children && React.createElement(Name, null, children),
            !!info && (React.createElement(React.Fragment, null,
                React.createElement(Tooltip, { content: info },
                    React.createElement(InfoIcon, null)))))));
};
export default HeaderColumn;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=HeaderColumn.js.map